import { useEffect, useState } from 'react';

import type { AdTechGlobal } from '@wetransfer/ad-sdk';

import {
  WT_AD_WALLPAPER_INITIALIZED,
  WT_AD_WALLPAPER_LOADED,
} from './constants';
import { getWallpaper } from './helpers';
import {
  getReadyInitialState,
  getInitializedInitialState,
} from './helpers/get-initial-state';

/**
 * Updates when the wallpaper SDK is available.
 */
export const useWallpaper = (): {
  isReady: boolean;
  isInitialized: boolean;
  wallpaper: AdTechGlobal['wallpaper'] | undefined;
} => {
  const [isReady, setIsReady] = useState(getReadyInitialState());

  const [isInitialized, setIsInitialized] = useState(
    getInitializedInitialState()
  );

  useEffect(() => {
    if (isReady) {
      return;
    }

    const handleIsReady = () => {
      setIsReady(true);
    };

    window.addEventListener(WT_AD_WALLPAPER_LOADED, handleIsReady);

    return () => {
      window.removeEventListener(WT_AD_WALLPAPER_LOADED, handleIsReady);
    };
  }, [isReady]);

  useEffect(() => {
    if (isInitialized) {
      return;
    }

    const handleIsInitialized = () => {
      setIsInitialized(true);
    };

    window.addEventListener(WT_AD_WALLPAPER_INITIALIZED, handleIsInitialized);

    return () =>
      window.removeEventListener(
        WT_AD_WALLPAPER_INITIALIZED,
        handleIsInitialized
      );
  }, [isInitialized]);

  return {
    isReady,
    isInitialized,
    wallpaper: getWallpaper(),
  };
};
